import React, { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Play } from "lucide-react";

const DURATION = 30;

export function AimTrainer({ onScore }) {
  const [target, setTarget] = useState(null);
  const [score, setScore] = useState(0);
  const [misses, setMisses] = useState(0);
  const [time, setTime] = useState(DURATION);
  const [running, setRunning] = useState(false);
  const [over, setOver] = useState(false);
  const reported = useRef(false);

  const spawn = () => setTarget({ x: 6 + Math.random() * 82, y: 6 + Math.random() * 82, size: 30 + Math.random() * 28 });

  const start = () => { setScore(0); setMisses(0); setTime(DURATION); setRunning(true); setOver(false); reported.current = false; spawn(); };

  useEffect(() => {
    if (!running) return;
    if (time <= 0) { setRunning(false); setOver(true); setTarget(null); return; }
    const t = setTimeout(() => setTime((x) => x - 1), 1000);
    return () => clearTimeout(t);
  }, [running, time]);

  const hit = (e) => { e.stopPropagation(); setScore((s) => s + 1); spawn(); };
  const missClick = () => { if (running) setMisses((m) => m + 1); };

  const acc = score + misses ? Math.round((score / (score + misses)) * 100) : 100;
  useEffect(() => { if (over && !reported.current) { reported.current = true; onScore?.(score * 30); } }, [over, score, onScore]);

  return (
    <div className="flex flex-col items-center w-full" data-testid="aim-trainer">
      <div className="flex items-center justify-between w-full max-w-md mb-3 font-mono">
        <span className="text-neon-cyan text-lg" data-testid="aim-score">HITS: {score}</span>
        <span className="text-neon-lime">ACC: {acc}%</span>
        <span className={`text-lg ${time <= 10 ? "text-neon-pink animate-blink" : "text-neon-yellow"}`}>⏱ {time}s</span>
      </div>
      <div onClick={missClick} className="relative bg-zinc-950 border-2 border-zinc-700 rounded-xl overflow-hidden w-full max-w-md cursor-crosshair" style={{ aspectRatio: "1" }}>
        {target && running && (
          <button onClick={hit} data-testid="aim-target"
            className="absolute rounded-full bg-neon-pink hover:scale-110 transition-transform"
            style={{ left: `${target.x}%`, top: `${target.y}%`, width: target.size, height: target.size, boxShadow: "0 0 18px #FF003C", border: "3px solid #fff" }} />
        )}
        {!running && (
          <div className="absolute inset-0 bg-black/85 flex flex-col items-center justify-center gap-3">
            {over && <p className="font-display font-black text-2xl text-neon-lime uppercase" data-testid="aim-over">Done! {score} hits · {acc}%</p>}
            <Button onClick={start} data-testid="aim-start" className="bg-neon-cyan text-black rounded-none font-bold uppercase">
              <Play className="w-4 h-4 mr-1 fill-black" /> {over ? "Play Again" : "Start"}
            </Button>
          </div>
        )}
      </div>
      <p className="text-zinc-500 text-xs font-mono mt-3">Click the targets as fast as you can. Don't miss!</p>
    </div>
  );
}
